// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 42-app-marketplace.md
import { initContract } from '@ts-rest/core';
import { MarketplaceAppSchema, MarketplaceListQuerySchema, paginated } from '@greenlight/shared';
import { errorResponses } from './common.js';
const c = initContract();
export const marketplaceContract = c.router({
    list: {
        method: 'GET',
        path: '/api/marketplace/apps',
        query: MarketplaceListQuerySchema,
        responses: {
            200: paginated(MarketplaceAppSchema),
            ...errorResponses,
        },
        summary: 'List the apps this caller can open (cursor-paginated), one discovery card shape for every caller. Always available: a restricted app is omitted for callers it does not admit rather than shown locked. Favorites sort above the rest and the caller’s hidden cards are excluded by default; pass include_hidden=true to include them.',
    },
});
//# sourceMappingURL=marketplace.js.map